var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('portal-target',{attrs:{"name":"printcard"}}),_c('v-content',{class:['main-content', { appHidden: !_vm.show }]},[_c('transition',{attrs:{"name":"fade-transition"}},[_c('router-view')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }